export default __webpack_public_path__ + "static/media/assegura3.6473b1af.png";